export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand">
      <svg width={compact ? 30 : 34} height={compact ? 30 : 34} viewBox="0 0 96 96" aria-hidden>
        <defs>
          <linearGradient id="brandArc" x1="14" y1="82" x2="82" y2="14" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#2563EB" />
            <stop offset=".55" stopColor="#3B82F6" />
            <stop offset="1" stopColor="#22D3EE" />
          </linearGradient>
          <linearGradient id="brandBar" x1="18" y1="48" x2="78" y2="48" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#E5007D" />
            <stop offset=".55" stopColor="#7C3AED" />
            <stop offset="1" stopColor="#2563EB" />
          </linearGradient>
        </defs>
        <path d="M78 30.7A33 33 0 1 0 78 65.3" fill="none" stroke="url(#brandArc)" strokeWidth="11" strokeLinecap="round" />
        <path d="M21 48h55" fill="none" stroke="url(#brandBar)" strokeWidth="11" strokeLinecap="round" />
      </svg>
      {!compact && (
        <div className="brand-text">
          <span className="brand-name">evocha</span>
          <span className="brand-line">Enabling Opportunities</span>
        </div>
      )}
    </div>
  );
}
